import React from "react";
import { EVENT_STATUS, QUOTE_STATUS } from "@/lib/constants";

export function StatusBadge({ status, type = "event", testid }) {
  const map = type === "event" ? EVENT_STATUS : QUOTE_STATUS;
  const s = map[status] || { label: status, cls: "bg-zinc-500/10 text-zinc-400 border-zinc-500/25", dot: "bg-zinc-400" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}
    >
      {s.dot && <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />}
      {s.label}
    </span>
  );
}
